import React from 'react';
import { technologies } from './data/content';
import './css/TechStack.css';

const TechStack: React.FC = () => {
  return (
    <section className="tech-stack" id="tech">
      <div className="container">
        <div className="section-header fade-in">
          <div className="section-tag">// Technology Stack</div>
          <h2>Tools & Technologies</h2>
          <p>Leveraging the latest cloud and development technologies</p>
        </div>

        <div className="tech-grid">
            {technologies.map((tech, index) => (
              <div key={index} className="tech-item fade-in">
                <a href={tech.url} target="_blank" rel="noopener noreferrer" className="icon">
                  {tech.icon}
                </a>
                <h4>
                  <a href={tech.url} target="_blank" rel="noopener noreferrer">
                    {tech.name}
                  </a>
                </h4>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default TechStack;
